import _regeneratorRuntime from "@babel/runtime/helpers/regeneratorRuntime";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useUserPermissions } from "../use-user-permissions";
import { useValidatedTargetSegment } from "../use-validated-target-segment/use-validated-target-segment";
import { useHanaAmplitude } from "../use-hana-amplitude";
import { useCopilotCreateConversationFromMessageMutationMutation } from "./graphql/create-conversation-from-chat-message.v5.generated";
export var useCreateConversationFromChatMessage = function useCreateConversationFromChatMessage(_ref) {
  var onCreateConversation = _ref.onCreateConversation,
    organizationId = _ref.organizationId,
    slug = _ref.slug,
    _ref$source = _ref.source,
    source = _ref$source === void 0 ? 'main' : _ref$source,
    role = _ref.role;
  var _useHanaAmplitude = useHanaAmplitude({
      slug: slug
    }),
    onSubmitPrompt = _useHanaAmplitude.onSubmitPrompt;
  var _useCopilotCreateConv = useCopilotCreateConversationFromMessageMutationMutation({
      context: {
        clientName: 'v5'
      }
    }),
    _useCopilotCreateConv2 = _slicedToArray(_useCopilotCreateConv, 2),
    createConversation = _useCopilotCreateConv2[0],
    loading = _useCopilotCreateConv2[1].loading;
  var _useUserPermissions = useUserPermissions({
      currentViewMode: role
    }),
    viewMode = _useUserPermissions.viewMode;
  var finalRole = useValidatedTargetSegment(viewMode);
  var submitPromptAndGetConversation = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee(_ref2) {
      var prompt, category, isExternal, chatId;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            prompt = _ref2.prompt, category = _ref2.category, isExternal = _ref2.isExternal;
            chatId = '';
            _context.next = 4;
            return createConversation({
              variables: {
                input: {
                  organization_id: (organizationId === null || organizationId === void 0 ? void 0 : organizationId.toString()) || '',
                  message: prompt || '',
                  role: finalRole,
                  source: source
                }
              },
              onCompleted: function onCompleted(response) {
                var _response$copilot, _chatResponse$chat_me, _chatResponse$chat_me2;
                var chatResponse = response === null || response === void 0 ? void 0 : (_response$copilot = response.copilot) === null || _response$copilot === void 0 ? void 0 : _response$copilot.create_conversation_from_message;
                chatId = chatResponse === null || chatResponse === void 0 ? void 0 : (_chatResponse$chat_me = chatResponse.chat_message) === null || _chatResponse$chat_me === void 0 ? void 0 : (_chatResponse$chat_me2 = _chatResponse$chat_me.chat_conversation) === null || _chatResponse$chat_me2 === void 0 ? void 0 : _chatResponse$chat_me2.id;
                if (chatId) {
                  var sourceText = isExternal ? 'Home' : 'Home Hana';
                  onSubmitPrompt(sourceText, {
                    text: prompt || '',
                    category: category || ''
                  });
                  if (onCreateConversation) {
                    var destination = "/org/".concat(slug, "/ai/").concat(viewMode, "/chat/").concat(chatId, "/");
                    onCreateConversation(destination);
                  }
                }
                return chatId;
              },
              onError: function onError(error) {
                onSubmitPrompt('Home Hana', {
                  text: prompt || '',
                  category: category || ''
                }, error.message);
                return chatId;
              }
            });
          case 4:
            return _context.abrupt("return", chatId);
          case 5:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function submitPromptAndGetConversation(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var createNewConversationFromHistorial = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
      var chatId;
      return _regeneratorRuntime().wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            chatId = '';
            _context2.next = 3;
            return createConversation({
              variables: {
                input: {
                  organization_id: (organizationId === null || organizationId === void 0 ? void 0 : organizationId.toString()) || '',
                  message: 'Hola'
                }
              },
              onCompleted: function onCompleted(response) {
                var _response$copilot2, _chatResponse$chat_me3, _chatResponse$chat_me4;
                var chatResponse = response === null || response === void 0 ? void 0 : (_response$copilot2 = response.copilot) === null || _response$copilot2 === void 0 ? void 0 : _response$copilot2.create_conversation_from_message;
                chatId = chatResponse === null || chatResponse === void 0 ? void 0 : (_chatResponse$chat_me3 = chatResponse.chat_message) === null || _chatResponse$chat_me3 === void 0 ? void 0 : (_chatResponse$chat_me4 = _chatResponse$chat_me3.chat_conversation) === null || _chatResponse$chat_me4 === void 0 ? void 0 : _chatResponse$chat_me4.id;
              }
            });
          case 3:
            return _context2.abrupt("return", chatId);
          case 4:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function createNewConversationFromHistorial() {
      return _ref4.apply(this, arguments);
    };
  }();
  return {
    submitPromptAndGetConversation: submitPromptAndGetConversation,
    createNewConversationFromHistorial: createNewConversationFromHistorial,
    loading: loading
  };
};